import { render } from "./ApiTokenManager.vue?vue&type=template&id=3d0d463e"
import script from "./ApiTokenManager.vue?vue&type=script&lang=js"
export * from "./ApiTokenManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__